// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"e244fb93","524":"16816c34","590":"bcfd83aa","731":"038e346e","787":"b701888c","921":"35982ebb"}[chunkId] + ".chunk.js";
};